// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Accounts Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Accounts Worker')

  // $FlowFixMe
  const AccountsWorker = require('worker-loader?name=[hash].accounts.wrkr.js!./worker.js')
  worker = new AccountsWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
